import { uiText } from '../../i18n/uiText';
import React, { useEffect, useState } from 'react';
import Dialog from './Dialog';
import { X } from 'lucide-react';
import { fileKindLabel, formatFileSize } from '../../utils/fileMeta';
import EvidenceImage from './EvidenceImage';

export default function AttachmentPreviewModal({ file, onClose, context, position, onPrevious, onNext }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [file?.id, file?.filename]);
  if (!file) return null;
  const url = file.url || `/uploads/${file.filename}`;
  const type = (file.file_type || file.detected_mime_type || '').toLowerCase();
  const isImage = type.startsWith('image/');
  const isPdf = type.includes('pdf');
  const isText = type.startsWith('text/') || type.includes('json') || type.includes('xml');

  return (
    <Dialog size="xl" className="ap-evidence-preview" label={file.original_name || uiText("Просмотр вложения")} onClose={onClose}>
        <div className="ap-dialog__header">
          <div style={{ minWidth: 0 }}>
            <div className="ap-dialog__title" data-dialog-heading tabIndex={-1}>{file.original_name}</div>
            <div className="ap-dialog__description">{fileKindLabel(file)} · {formatFileSize(file.file_size)}{context ? ` · ${context}` : ''}</div>
          </div>
          <div className="ap-dialog__header-actions">
            <a className="ap-button ap-button--secondary ap-button--sm" href={url} target="_blank" rel="noreferrer" download={file.original_name}>{uiText("Скачать")}</a>
            <button type="button" className="ap-button ap-button--secondary ap-button--sm" onClick={onClose}><X size={14} />{uiText(" Закрыть")}</button>
          </div>
        </div>
        <div className="ap-dialog__body">
          {position && <div className="ap-evidence-pager" aria-label={uiText("Навигация по вложениям")}>
            <button type="button" className="ap-button ap-button--secondary ap-button--sm" disabled={!onPrevious} onClick={onPrevious}>{uiText("Предыдущий")}</button>
            <span role="status">{position}</span>
            <button type="button" className="ap-button ap-button--secondary ap-button--sm" disabled={!onNext} onClick={onNext}>{uiText("Следующий")}</button>
          </div>}
          {failed && <div className="ap-save-notice" role="alert">{uiText("Не удалось загрузить изображение. Проверьте соединение или воспользуйтесь кнопкой «Скачать».")}</div>}
          {isImage && !failed && <EvidenceImage key={file.id||url} file={file} onError={() => setFailed(true)} />}
          {(isPdf || isText) && <iframe title={file.original_name} src={url} className="ap-dialog__preview" />}
          {!isImage && !isPdf && !isText && (
            <div className="empty-state">
              <h3>{uiText("Предпросмотр для этого типа файла недоступен")}</h3>
              <p>{uiText("Можно скачать вложение или открыть его в новой вкладке системным средством браузера.")}</p>
              <div style={{ marginTop: 12 }}>
                <a className="ap-button ap-button--primary" href={url} target="_blank" rel="noreferrer">{uiText("Открыть файл")}</a>
              </div>
            </div>
          )}
        </div>
    </Dialog>
  );
}
